import { render, staticRenderFns } from "./WinPopup.vue?vue&type=template&id=1b0263c6&scoped=true"
import script from "./WinPopup.vue?vue&type=script&lang=js"
export * from "./WinPopup.vue?vue&type=script&lang=js"
import style0 from "./WinPopup.vue?vue&type=style&index=0&id=1b0263c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0263c6",
  null
  
)

export default component.exports